import React from "react"
import CountUp from "react-countup"

const Counter = ({ title, number, titleColor = "" }) => {
  return (
    <div className="col-md-4">
      <h3 className={`counter counter-lg ${titleColor}`}>
        <CountUp end={number} />
      </h3>

      <p>{title}</p>
    </div>
  )
}

export default Counter
